import React from 'react';
import './ProjectNote.css';

const ProjectNote = ({ text }) => {
  return <div className="note">{text}</div>;
};

export default ProjectNote;